import React, {useEffect, useState, useRef} from "react";
import {
  FlatList,
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  ScrollView,
  Animated,
} from "react-native";
import {connect} from "react-redux";
import {Color, globalFontStyle, globalStyle} from "../../../assets";

import {TEST_API} from "../../../utils/apiUrl";
import {
  globalConfigurableData,
  GlobalScreens,
} from "../../../utils/globalConstant";
import {setHomeFilterCategory} from "../redux/home.action";
import {isMobile} from "../../../utils/commonMethods";
import Colors from "../../../assets/Color/Colors";

const AnimatedTouchable = Animated.createAnimatedComponent(TouchableOpacity);

const CategoryItemAnimated = ({ item, isSelected, onPress }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <TouchableOpacity
      onPress={onPress}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={[
        styles.categoryItem,
        isHovered && !isSelected && { backgroundColor: '#FAFAFA' }
      ]}>
      <View style={styles.categoryContent}>
        {item.icon && (
          <Image 
            source={item.icon}
            style={[
              styles.categoryIcon,
              (isSelected || isHovered) && styles.categoryIconSelected
            ]}
          />
        )}
        <Text style={[
          styles.categoryText,
          isSelected && styles.categoryTextSelected,
          isHovered && !isSelected && { color: '#000000' }
        ]}>
          {item.text}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

const CategoriesHome = props => {
  const {globalConfigData, onCategoryUpdate, selectedCategory} = props;
  const serverURL = TEST_API;
  const imagePath = `../../../assets/categoryIcon/`;
  const [isHome, setHome] = useState(false);
  //const [selectedCategory, setSelectedCategory] = useState('');

  const onCategoryPress = item => {
    //setSelectedCategory(item);
    //props.setHomeFilterCategory(item);
    /*if (!isHome) {
      setHome(true);
    }*/
  };

  const renderCategories = item => {
    return <Text>{item?.text}</Text>;
  };

  useEffect(() => {
    if (
      globalConfigData?.categories &&
      globalConfigData?.categories.length > 0 &&
      props?.filterOrder
    ) {
      const index = globalConfigData?.categories.findIndex(obj => {
        if (obj.text === props?.filterOrder) return true;
      });
      if (index !== -1) {
        // setSelectValue(props?.filterOrder);

        onCategoryUpdate(globalConfigData?.categories[index]);
        props.setHomeFilterCategory(null);
      }
    }
  }, [globalConfigData?.categories, props?.filterOrder]);

  return (
    <View style={styles.mainContainer}>
      {globalConfigData && globalConfigData?.categories?.length > 0 && (
        <View style={styles.categoriesContainer}>
          {!isMobile() && <View style={{flex: 1}} />}
          <FlatList
            horizontal
            contentContainerStyle={[
              styles.listContainer,
              isMobile() && styles.mobileListContainer
            ]}
            data={globalConfigData?.categories}
            renderItem={itemList => {
              const isItemSelected = selectedCategory === itemList?.item?.text;
              return (
                <CategoryItemAnimated
                  item={itemList?.item}
                  isSelected={isItemSelected}
                  onPress={() => {
                    onCategoryUpdate(itemList?.item);
                  }}
                />
              );
            }}
            keyExtractor={txn => txn.id}
            showsHorizontalScrollIndicator={false}
          />
        </View>
      )}
    </View>
  );
};

const mapStateToProps = ({utilReducer, probesReducer}) => ({
  globalConfigData: utilReducer.globalConfigData,
  filterOrder: probesReducer.filterOrder,
});
const mapDispatchToProps = {
  setHomeFilterCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesHome);

const styles = StyleSheet.create({
  mainContainer: {
    width: '100%',
  },
  categoriesContainer: {
    borderBottomWidth: 1,
    borderColor: '#EEEEEE',
    flexDirection: 'row',
    marginHorizontal: -16,
  },
  listContainer: {
    flexGrow: 0,
    paddingHorizontal: 16,
  },
  mobileListContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  categoryItem: {
    paddingHorizontal: 8,
    paddingVertical: 16,
    backgroundColor: 'transparent',
  },
  categoryContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  categoryIcon: {
    width: 18,
    height: 18,
    marginRight: 8,
    tintColor: '#666666',
  },
  categoryIconSelected: {
    tintColor: '#000000',
  },
  categoryText: {
    ...globalFontStyle.appFontSubHeading,
    color: '#666666',
    fontSize: 12,
    fontWeight: '400',
  },
  categoryTextSelected: {
    color: '#000000',
    fontWeight: '600',
  },
  mobileCategoryContainer: {
    marginBottom: 8,
  },
  mobileCategoryText: {
    fontSize: 14,
  },
});
